import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@getro/rombo';

import MfaSetupSteps from './MfaSetupSteps';

const MfaSetupModal = ({ setupData, onCancel, onSubmit }) => (
  <Modal title="Set up two-factor authentication" onCancel={onCancel}>
    <MfaSetupSteps setupData={setupData} onSubmit={onSubmit} dataCyPrefix="mfa-setup" />
  </Modal>
);

MfaSetupModal.propTypes = {
  setupData: PropTypes.shape({
    qrCode: PropTypes.string.isRequired,
    secret: PropTypes.string.isRequired,
  }).isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default MfaSetupModal;
